import { watch } from "vue";
import { useRouter } from "#app";

let initialized = false;

function injectGtm(gtmId) {
  if (!gtmId || initialized) return;
  initialized = true;

  // bootstrap dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  // add GTM script
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
  document.head.appendChild(script);

  // optional noscript fallback
  const noscript = document.createElement("noscript");
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(gtmId)}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.appendChild(noscript);
}

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const gtmReference = useState("gtm-reference");

  // if it's already set when plugin runs
  if (gtmReference.value) {
    injectGtm(gtmReference.value);
  }

  // watch for it to arrive later
  watch(gtmReference, (id) => {
    if (id) {
      injectGtm(id);
    }
  });

  // push SPA navigation events to dataLayer
  router.afterEach((to) => {
    if (!window.dataLayer) {
      return;
    }

    window.dataLayer.push({
      event: "page-view",
      "page.path": to.fullPath,
      "page.title": document.title || (to.meta && to.meta.title) || "",
    });
  });
});
